import { createSelector } from 'reselect'

export const getNewLogo = createSelector(
  state => state && state.user && state.user.profile && state.user.profile.newLogo
    ? state.user.profile.newLogo
    : null,
  logo => logo
)
